class ContactService {
  static instance: ContactService;

async getContactUs() {
    return fetch(`${import.meta.env.VITE_API_BASE_URL}form/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  async contactUs(data: any) {
    return fetch(`${import.meta.env.VITE_API_BASE_URL}form/`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
}

export default new ContactService();